<template>
    
  <el-popover
    placement="bottom-start"
    v-if="mode == 'tag'"
    :width="width"
    @hide="popHide"
    :disabled="(disabled || !onlyInput) && !editMode"
    v-model="popShow"
    @show="showHandler"
    :visible-arrow="false"
    popper-class="noPadding tag-select-pop"
    trigger="click">
    <div class="tag-box">
      <div class="tag-top flex">
        <el-input autofocus clearable size="mini" style="width: 100%;flex: 1" class="noborder" placeholder="搜索" prefix-icon="el-icon-search" v-model="kw"></el-input>
        <el-button v-if="isCanAddDataItem" type="text" size="mini" @click="add" icon="el-icon-plus" style="margin-right: 12px">{{ $t('新增') }}</el-button>
      </div>
      <div class="tag-pop-list">
        <div class="tag-pop-list-item" @click="selectItem(i)" :class="{'active': values.includes(i[valueKey]) }" v-for="i in showTags" :key="i[valueKey]">
          <div class="tagel ellipsis" :style="{color: i[colorKey] || '#242456', background: fadeColor(i[colorKey] || '#242456')}">
            {{ i[labelKey] }}
          </div>
        </div>
        <div v-if="inputOther" class="tag-pop-list-item flex" :class="{'active': otherActive }" @click="clickOther">
          <div class="tagel ellipsis" style="min-width: 26px;" :style="{background: fadeColor('#242456')}">
            其他
          </div>
          <el-input class="other-input" size="mini" v-model="otherInput" @input="otherInputChange" @change="popShow = false"></el-input>
        </div>
      </div>
    </div>
    <div ref="main" slot="reference" class="select-component-box" :style="{'padding-right': !onlyInput && !disabled ? '28px' : 0, 'padding-left': onlyInput && !disabled ? '8px' : 0}" :class="{'active': popShow, 'has-val': value || (value === 0), 'only-input': onlyInput && !disabled, 'is-disabled': disabled && onlyInput, 'print': printMode}" >
      <div class="tag-list" :class="{'active': popShow}">
          <div v-if="!value" class="placeholder">
              {{ placeholder }}
          </div>
          <div class="tagel ellipsis" :title="getItem(i, labelKey) || otherInput || '其他'" v-for="i in (values.length ? values.slice(0, collapseTags && multiple ? 1 : values.length) : [])" :key="i" :style="{color: getItem(i, colorKey) || '#242456', background: fadeColor(getItem(i, colorKey) || '#242456')}">
              {{ getItem(i, labelKey) || otherInput || '其他' }}
              <i v-if="multiple && !disabled && !hideClose" class="el-icon-error" style="cursor: pointer" @click.stop="clearVal(i)"></i>
          </div>
          <div v-if="this.values.length - 1 > 0 && collapseTags && multiple" class="tagel ellipsis" :style="{background: '#f5f6f8', color: '#666'}">
              +{{ this.values.length - 1 }}
          </div>
          <span v-if="!onlyInput && !editMode && !disabled" class="edit-icon" @click.stop="toEdit">
            <i class="el-icon-edit"></i>
          </span>
          <span v-if="(onlyInput || editMode) && !popShow && !disabled" class="edit-icon arrow">
            <i class="el-icon-arrow-down"></i>
          </span>
          <span v-if="(onlyInput || editMode) && popShow && !disabled" class="edit-icon arrow">
            <i class="el-icon-arrow-up"></i>
          </span>
          <span v-if="(onlyInput || editMode) && !disabled && clearable" class="edit-icon clear" @click.stop="clear">
            <i class="el-icon-error"></i>
          </span>
          
      </div>
    </div>
  </el-popover>
    

  <span v-else-if="disabled && printMode" class='showText'>{{showTxt}}</span>
    <el-select
    v-else
    ref="main"
    class="l-select"
    :class="{ 'add-box': isCanAddDataItem }"
    :size="size"
    v-model="value2"
    v-disableSel="[myOptions, value2, valueKey, multiple]"
    :collapse-tags="collapseTags"
    :multiple="multiple"
    :value-key="valueKey"
    :disabled="disabled"
    :placeholder="placeholder"
    :filterable="filterable"
    :filterMethod="filterMethod"
    :remoteMethod="remoteMethod"
    :loadingText="loadingText"
    :clearable="clearable"
    :allow-create="allowCreate"
    :loading="loading"
    :remote="remote"
    :popper-class="popperClass"
    @change="handleChange"
    @clear="handleClear"
    @visible-change="handleVisibleChange"
    >
        <template v-slot:prefix>
        <slot name="prefix">
          <el-button v-if="isCanAddDataItem" :size="size" type="text" icon="el-icon-plus" @click.stop="add">{{$t('新增')}}</el-button>
        </slot>
        </template>
    <template v-if="seachLoopUp">
        <el-option
            :disabled="true"
            class="meterHead"
            style="color: #595959 !important;
            font-weight: 700 !important;
            background: #f6f8fa !important;
            "
            value="seachLoopUpHeader"
            v-if="hasHeader"
        >
            <div class="flex">
            <div v-for="(i, idx) in searchList" v-if="i.header" :title="i.header" :key="idx" class="ellipsis" :style="{width: `${i.width || 60}px`}">
                {{i.header}}
            </div>
            </div>
        </el-option>
        <div style="height: 34px;" v-if="bol"></div>
        <el-option
        v-for="(item, index) in myOptions" 
        :key="index"
        :label="item[labelKey]"
        :value="item[valueKey]"
        :disabled="item[disabledKey] || false"
        >
        <div class="flex">
            <div v-for="(i, idx) in searchList" :title="item[i.key]" :key="idx" class="ellipsis" :style="{width: `${i.width || 60}px`}">
            {{item[i.key]}}
            </div>
        </div>
        </el-option>
    </template>
    <template v-else>
      <slot>
        <el-option
          v-for="(item, index) in myOptions"
          :key="index"
          :label="item[labelKey]"
          :value="item[valueKey]"
          :disabled="item[disabledKey] || false || disabledList.includes(item[valueKey])"
          >
          </el-option>
      </slot>
    </template>
    
    </el-select>

</template>
<script>
export default {
name: "l-select",
props: {
  popperClass: {
    type: String,
  },
  interval: {
    default: '、'
  },
  onlyInput: {
    default: true,
  },
  mode: {
    default: '' // tag 便签选择器
  },
  value: {},
  placeholder: String,
  labelKey: {
    type: String,
    default: "label",
  },
  valueKey: {
    type: String,
    default: "value",
  },
  colorKey: {
    type: String,
    default: "color",
  },
  disabledKey: {
    type: String,
    default: "disabled",
  },
  // 禁用主键列表
  disabledList: {
    type: String,
    default: "",
  },
  size:{
    type:String,
    default:'mini'
  },
  options: {
    type: Array,
    default: () => {
      return [];
    },
  },
  disabled: Boolean,
  filterable: {
    type: Boolean,
    default: true,
  },
  filterMethod: Function,
  remoteMethod: Function,
  multiple: Boolean,
  collapseTags: Boolean,
  clearable: {
    type: Boolean,
    default: true,
  },
  printMode: {
    default: false
  },
  loading: {
    default: false
  },
  loadingText: {
    default: '加载中'
  },
  remote: {
    default: false
  },
  seachLoopUp: {
    default: false
  },
  searchList: {
    default: () => {
      return [] // {header: '', key: '', width: ''}
    }
  },
  allowCreate: {
    default: false
  },
  otherColor: {
    default: '#f5f6f8'
  },
  inputOther: {
    default: false
  },
  hideClose: {
    default: false
  },
  dataCode: {
    default: ''
  },
  dataType: {
    default: ''
  },
  isQuery: { // 是否用作查询控件
    default: false
  },
  diyAddFuc: { // 自定义添加方法
    default: null
  }
},
directives: {
  disableSel: {
    bind (el, bindings) {
      const [mapData, selData, valueKey, multiple] = bindings.value
      if (!multiple) return
      const disableIndex = []
      selData.forEach((selItem, index) => {
        const selObj = mapData.find(e => e[valueKey] === selItem)
        if (selObj && selObj.disabled) disableIndex.push(index)
      })
      setTimeout(() => { // bind时，找不到 tags，所以放个延时定时器
        const tags = el.querySelectorAll('.el-tag__close')
        tags.forEach((tag, index) => {
          if (disableIndex.includes(index)) {
            tag.classList.add('none')
          }
        })
      }, 100)
    }
  }
},
created() {},
data() {
  return {
    bol:false,
    popShow: false,
    width: 200,
    kw: '',
    editMode: false,
    otherInput: '',
    timer: null,
    diyOptions: null,
    classifysVisible: false
  };
},
mounted() {
  this.$nextTick(() => {
    this.$refs.main && (this.width = this.$refs.main.clientWidth + 4)
  })
},
computed: {
  isCanAddDataItem() {
    return this.dataCode && !this.disabled && this.dataType != '3' && !this.isQuery
  },
  otherActive() {
    let vals = this.myOptions.map(e => e[this.valueKey])
    if (this.value && !vals.includes(this.value)) {
      return true
    }
    return false
  },
  hasHeader:{
    get(){
      let bol = false
      this.searchList.forEach(item => {
        if(item.header){
          bol = true
        }
      })
      return bol
    }
  },
  value2: {
    get() {
      if (this.multiple) {
        if (!this.$validatenull(this.value)) {
          return (this.value + "").split(",");
        } else {
          return [];
        }
      } else {
        return this.value;
      }
    },
    set(val) {
      if (this.multiple) {
        this.$emit("input", String(val));
      } else {
        this.$emit("input", val);
      }
    },
  },
  showTxt () {
      if (!this.myOptions.length) return this.value || ''
      let arr = this.value ? String(this.value).split(',') : [],
          brr = []
      arr.forEach(e => {
          let item = this.myOptions.find(i => i[this.valueKey] == e)
          item && brr.push(item[this.labelKey] || e)
      });
      let str = brr.join(this.interval)
      if (this.value && !str) str = this.value
      return str
  },
  myOptions() {
    let isArr = this.options instanceof Array
    if (!isArr) return []
    return (this.diyOptions || this.options).map(e => {
      if (e[this.valueKey] !== '') {
        if (typeof this.value == "boolean" && typeof e[this.valueKey] == "string") {
          e[this.valueKey] = e[this.valueKey] == "true" ? true : false;
        } else if (typeof this.value == "number") {
          e[this.valueKey] = e[this.valueKey]*1
        }
      }
      return e
    })
  },
  showTags() {
    return this.myOptions.filter(e => (this.kw && e[this.labelKey].includes(this.kw)) || !this.kw)
  },
  values() {
    if (this.$validatenull(this.value)) return []
    if (!this.multiple) return [this.value]
    return this.value.split(',')
  }
},
methods: {
  add() {
    if (this.diyAddFuc) return this.diyAddFuc()
    this.$cateManageDg.show({
      code: this.dataCode,
      // title: this.$t('选项管理')
    })
  //   let items = [{
  //       type: 'input',
  //       key: 'f_ItemName',
  //       label: this.$t('选项'),
  //       value: '',
  //       clearable: true,
  //       rules: [{ required: true, message: this.$t('请输入选项') }]
  //   }]
  //   if (this.mode == 'tag') {
  //     items.push({
  //       type: 'l-input-color',
  //       key: 'f_Color',
  //       label: this.$t('标签颜色'),
  //       value: '',
  //       clearable: true
  //     })
  //   }
  //   this.$dForm.show({
  //     title: this.$t(`新增选项`),
  //     width: '500px',
  //     height: 200,
  //     labelWidth: '100px',
  //     items,
  //     callback: async (form, that) => {
  //         let data = {}
  //         data.f_ItemName = form.f_ItemName
  //         data.f_ItemValue = form.f_ItemName
  //         data.f_Color = form.f_Color
  //         data.f_SortCode = this.myOptions.length + 1
  //         let res = await this.$awaitWraper(window.$axios({
  //             url: `data/dataitem/detail/${this.dataCode}`,
  //             method: 'POST',
  //             data
  //         }))
  //         if (res) {
  //             this.$tip('新增成功')
  //             that.hide()
  //             this.selectItem(data)
  //             this.lr_loadDataItem(this.dataCode, false)
  //         }
  //     }
  // })
  },
  fadeColor(color, fadeRatio=0.2) {
      
      let r, g, b, a = 1;
      
      // 解析不同格式的颜色
      if (color.startsWith('rgba(')) {
          // rgba(255, 140, 0, 1) 格式
          const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
          if (match) {
              r = parseInt(match[1]);
              g = parseInt(match[2]);
              b = parseInt(match[3]);
              a = match[4] ? parseFloat(match[4]) : 1;
          }
      } else if (color.startsWith('rgb(')) {
          // rgb(255, 140, 0) 格式
          const match = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
          if (match) {
              r = parseInt(match[1]);
              g = parseInt(match[2]);
              b = parseInt(match[3]);
          }
      } else if (color.startsWith('#')) {
          // #FFF 或 #FFFFFF 格式
          let hex = color.slice(1);
          if (hex.length === 3) {
              // #FFF 格式转为 #FFFFFF
              hex = hex.split('').map(char => char + char).join('');
          }
          r = parseInt(hex.substr(0, 2), 16);
          g = parseInt(hex.substr(2, 2), 16);
          b = parseInt(hex.substr(4, 2), 16);
      } else {
          throw new Error('不支持的颜色格式');
      }
      
      // 计算淡化后的透明度
      const fadedAlpha = a * fadeRatio;
      
      // 返回rgba格式的淡化颜色
      return `rgba(${r}, ${g}, ${b}, ${fadedAlpha.toFixed(2)})`;
  },
  showHandler() {
    this.$refs.main && (this.width = this.$refs.main.clientWidth + 4)
    if (this.timer) clearInterval(this.timer)
    this.timer = setInterval(() => {
      this.isBlur()
    }, 200);
  },
  isBlur() {
    let each = (node) => {
      if (node._prevClass && (node._prevClass.indexOf('select-component-box') > -1 || node._prevClass.indexOf('tag-select-pop') > -1)) {
        return
      } else if (node.parentNode) {
        each(node.parentNode)
      } else {
        if (this.timer) clearInterval(this.timer)
        this.timer = null
        this.popShow = false
      }
    }
    each(document.activeElement)
  },
  setVal() {

  },
  otherInputChange() {
    if (!this.multiple) {
      this.$emit('input', this.otherInput || '其他')
      this.$emit('change', this.otherInput || '其他')
      this.dispatch("ElFormItem", "el.form.change", this.value)
    }
  },
  clearVal(val) {
    let arr = this.$deepClone(this.values)
    arr = arr.filter(e => e != val)
    this.$emit('input', arr.join(','))
    this.$emit('change', arr.join(','))
    this.dispatch("ElFormItem", "el.form.change", this.value)
  },
  selectItem(i) {
    if (!this.multiple) {
      this.$emit('input', i[this.valueKey])
      this.$emit('change', i[this.valueKey])
      this.dispatch("ElFormItem", "el.form.change", this.value)
      this.popShow = false
    } else {
      let arr = this.$deepClone(this.values)
      if (this.values.includes(i[this.valueKey])) {
        arr = arr.filter(e => e != i[this.valueKey])
        
      } else {
        arr.push(i[this.valueKey])
      }
      this.$emit('input', arr.join(','))
      this.$emit('change', arr.join(','))
      this.dispatch("ElFormItem", "el.form.change", this.value)
    }
  },
  clickOther() {
    if (!this.multiple) {
      this.$emit('input', this.otherInput || '其他')
      this.$emit('change', this.otherInput || '其他')
      this.dispatch("ElFormItem", "el.form.change", this.value)
    }
    this.$nextTick(() => {
      // this.$refs.other.focus()
    })
  },
  dispatch(componentName, eventName, params) {
    var parent = this.$parent || this.$root;
    var name = parent.$options.componentName;

    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent;

      if (parent) {
        name = parent.$options.componentName;
      }
    }
    if (parent) {
      parent.$emit.apply(parent, [eventName].concat(params));
    }
  },
  popHide() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (!this.onlyInput) this.editMode = false
  },
  toEdit() {
    this.width = this.$refs.main.clientWidth + 4
    this.editMode = true
    this.$nextTick(() => {
      this.popShow = true
    })
  },
  getItem(value, key) {
    let item = this.myOptions.find(i => i[this.valueKey] == value)
    if (key) {
      if (!item && key == this.labelKey && value) {
        this.otherInput = value
      }
      return (item && !this.$validatenull(item[key]) ? item[key] : '') || ((key == this.labelKey) ? value : '')
    }
    return item || value
  },
  handleChange(val) {
    if (this.multiple) {
      if (val.length == 0) {
        this.$emit("change", undefined);
        return;
      }

      const objs = [];
      val.forEach((item) => {
        const objone = this.myOptions.find((t) => t[this.valueKey] == item);
        objs.push(objone);
      });
      this.$emit("change", objs);
    } else {
      if (val == "") {
        this.$emit("change", undefined);
        return;
      }
      const obj = this.myOptions.find((t) => t[this.valueKey] == val);
      this.$emit("change", obj);
    }
  },
  clear () {
    this.$emit('input', '')
    this.$emit('change', '')
    this.$emit('clear')
    this.dispatch("ElFormItem", "el.form.change", this.value)
    this.popShow = false
  },
  handleClear() {
    this.$emit("clear");
  },
  handleVisibleChange(e) {
    this.$emit("visibleChange", e);
  },
  focus() {
    this.$refs.main.focus()
  }
},
};
</script>
<style lang="less">
@import "./index.less";
 
  // ::v-deep {
    .add-box {
      .el-select__tags {
            padding-left: 52px !important;
      }
      .el-input__inner {
        padding-left: 68px !important;
      }
      .el-button--text {
        color: #0d68ff !important;
      }
      .el-button--text:hover {
        background-color: transparent !important;
      }
      .el-input__prefix {
        z-index: 99;
      }
    }
  // }

.none {
  display: none;
}
.meterHead_none{
  display: none;
}
.meterHead{
  font-family: "Open Sans", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  width: inherit;
  position: sticky;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  ::v-deep{
    .el-select-dropdown__item.is-disabled{
      color: #000 !important;
      font-weight: bold !important;
      background: #eee !important;
    }
  }
}
.tag-box {
    .tag-top {
      border-bottom: 1px solid #EBECEE;
    }
    .tag-pop-list {
      padding: 4px;
      .tag-pop-list-item {
        padding: 3px 8px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:hover {
          background: rgba(33, 33, 33, .1);
        }
        &.active {
          background-color: #e6f8f5;
          .other-input {
            display: inline-block;
          }
        }
        .other-input {
          display: none;
        }
      }
    }
  }
  
  .tagel {
    display: inline-block ;
    margin: 3px 4px 3px 0;
    border-radius: 2px;
    padding: 0 6px;
    font-size: 12px;
    line-height: 20px;
    max-width: 100%;
  }
  .select-component-box {
    // display: inline-block;
    height: 28px;
    position: relative;
    border-radius: 4px;
    // padding-left: 8px;
    box-sizing: border-box;
    border: 1px solid transparent;
    &.only-input {
      border: 1px solid #d9d9d9;
      background: #FFF;
      // padding-left: 8px;
    }
    &.active {
      border: 1px solid #0d68ff !important;
    }
    &.is-disabled {
      border: 1px solid #d9d9d9;
      background-color: #f5f7fa;
    }
    &.print.is-disabled {
      border: none !important;
      padding-right: 0;
    }
    &:hover {
      .edit-icon {
        display: inline-flex;
        &.clear {
          display: none;
        }
      }
    }
    &.has-val {
      &:hover {
        .edit-icon {
          display: inline-flex;
          &.arrow {
            display: none;
          }
        }
      }
    }
    
    padding-right: 28px;
    .tag-list {
      // line-height: 28px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      min-height: 26px;
      
    }
    .edit-icon {
      display: none;
      cursor: pointer;
      font-size: 14px;
      padding: 0 7px;
      color: #525967;
      align-items: center;
      position: absolute;
      height: 26px;
      top: 0;
      right: 0;
      &.clear {
        z-index: 10;
      }
      &.arrow {
        display: inline-flex;
      }
    }
  }
  .placeholder {
    color: #bfbfbf;
    font-size: 12px;
    line-height: 26px;
  }
</style>
